export const EmptyStateMessage = () => {
    return (
      <div className='flex flex-col items-center justify-center h-full gap-4'>
          <img src="/empty-state.gif" className="w-56" />
          <p className='text-sm italic font-light'>Nenhum dado disponível no momento</p>
        </div>
    )
}
  